import React from "react"

import { Button } from "../button/button"
import { ICardFooter } from "./model"
import { BeatLoader } from "react-spinners"

import "./style.scss"

export const CardFooter = (props: ICardFooter) => {
    const { className, nextAction, currentCount, maxCount, children, disabled } = props

    return (
        <div className={`crf ${className ? className : ""}`}>
            {currentCount && maxCount && <div className="crf-step">{`Step ${currentCount} of ${maxCount}`}</div>}
            {nextAction && (
                <Button
                    className={`submit-btn ${className && !currentCount && !maxCount ? className : ""}`}
                    onClick={nextAction}
                    disabled={disabled}
                >
                    {disabled ? <BeatLoader size={7} margin={"2px"} color={"#ffffff"} /> : children ? children : "Next"}
                </Button>
            )}
        </div>
    )
}
